"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _customField = _interopRequireDefault(require("../../../../_common/formik/customField"));

var _businessHours = _interopRequireDefault(require("../businessHours"));

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AdditionalInfo = function AdditionalInfo(_ref) {
  var setFieldValue = _ref.setFieldValue,
      handleChange = _ref.handleChange,
      temporarilyClosed = _ref.temporarilyClosed;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pb-3 w-full"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "font-lato text-lightBlue"
  }, "Business Hours"), /*#__PURE__*/_react.default.createElement(_customField.default, {
    name: "businessHours",
    CustomComponent: _businessHours.default,
    setFieldValue: setFieldValue,
    fast: true
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "font-lato text-lightBlue"
  }, "Languages Spoken"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _TextField.default,
    name: "languagesSpoken",
    placeholder: "Spanish",
    label: "Languages Spoken",
    fullWidth: true,
    inputProps: {
      maxLength: 500
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "font-lato text-lightBlue"
  }, "How Many Infusion Chairs Do You Have At This Location?"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _TextField.default,
    name: "numberOfChairs",
    label: "# Chairs",
    placeholder: "3",
    fullWidth: true,
    type: "number",
    inputProps: {
      maxLength: 4
    }
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "mb-12"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "font-lato text-lightBlue"
  }, "Social Media URLs"), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _TextField.default,
    name: "facebookPageId",
    label: "Facebook ID",
    placeholder: "283746362",
    fullWidth: true,
    helperText: /*#__PURE__*/_react.default.createElement("a", {
      href: "https://www.facebook.com/help/1503421039731588",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "How do I find my Facebook Page ID?"),
    inputProps: {
      maxLength: 100
    }
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop20"
  }, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _TextField.default,
    name: "twitterHandle",
    label: "Twitter Handle",
    placeholder: "@your_company",
    fullWidth: true,
    helperText: "@example",
    inputProps: {
      maxLength: 100
    }
  }))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: "font-lato text-lightBlue"
  }, "Temporarily Closed"), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "flex align-items-center"
  }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
    name: "temporarily_closed",
    onChange: handleChange,
    color: "primary",
    checked: Boolean(temporarilyClosed)
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "location-details-label flex align-items-center"
  }, "This location is temporarily closed")), /*#__PURE__*/_react.default.createElement("div", {
    className: "marginTop20"
  }, /*#__PURE__*/_react.default.createElement(_customField.default, {
    CustomComponent: _TextField.default,
    name: "temporarily_closed_reason",
    label: "Temporarily Closed Reason",
    placeholder: "Flooded",
    fullWidth: true,
    helperText: "Please tell us why this location is temporarily closed and when it might re-open.",
    inputProps: {
      maxLength: 500
    }
  }))));
};

var _default = AdditionalInfo;
exports.default = _default;